import { Loader } from '@aws-amplify/ui-react';
import { TbCheck, TbCircle } from 'react-icons/tb';
import './ReviewProgressSteps.scss';

// Review step keys - must match backend ReviewStepKey enum
export enum ReviewStepKey {
  FETCHING_DATA = 'FETCHING_DATA',
  VALIDATING_EMAILS = 'VALIDATING_EMAILS',
  COMPARING_WITH_CRM = 'COMPARING_WITH_CRM',
  FINALIZING = 'FINALIZING'
}

// Ordered steps with labels
export const REVIEW_STEPS: { key: ReviewStepKey; label: string }[] = [
  { key: ReviewStepKey.FETCHING_DATA, label: 'Fetching data for review' },
  { key: ReviewStepKey.VALIDATING_EMAILS, label: 'Validating emails' },
  { key: ReviewStepKey.COMPARING_WITH_CRM, label: 'Comparing data with your HubSpot account' },
  { key: ReviewStepKey.FINALIZING, label: 'Finalizing review' }
];

interface ReviewProgressStepsProps {
  // Keys are plain strings so other flows with their own steps - the match run's, for
  // one - render through this component rather than restating the same markup.
  steps: { key: string; label: string }[];
  currentStep: string;
}

export function ReviewProgressSteps({ steps, currentStep }: ReviewProgressStepsProps) {
  const currentIndex = steps.findIndex(s => s.key === currentStep);

  return (
    <div className="review-progress-steps">
      {steps.map((step, index) => {
        const status = index < currentIndex ? 'completed'
                     : index === currentIndex ? 'in_progress'
                     : 'pending';
        return (
          <div key={step.key} className={`review-progress-step review-progress-step--${status}`}>
            <div className="review-progress-step__icon">
              {status === 'completed' && <TbCheck />}
              {status === 'in_progress' && <Loader size="small" />}
              {status === 'pending' && <TbCircle />}
            </div>
            <span className="review-progress-step__label">{step.label}</span>
          </div>
        );
      })}
    </div>
  );
}
